import { render, staticRenderFns } from "./oa-upload.vue?vue&type=template&id=16113cc1&scoped=true"
import script from "./oa-upload.vue?vue&type=script&lang=js"
export * from "./oa-upload.vue?vue&type=script&lang=js"
import style0 from "./oa-upload.vue?vue&type=style&index=0&id=16113cc1&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16113cc1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16113cc1')) {
      api.createRecord('16113cc1', component.options)
    } else {
      api.reload('16113cc1', component.options)
    }
    module.hot.accept("./oa-upload.vue?vue&type=template&id=16113cc1&scoped=true", function () {
      api.rerender('16113cc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-common/oa-upload.vue"
export default component.exports